/** Validate the given IBAN length to show specific error message in the CompanyInfoDialog.tsx component. General validation seems to be handled by the ABankAccountInput and the API.   */
export const isIbanLengthValid = (iban: string | null) => {
    return iban && iban.replace(/\s+/g, '').length === 18 ? true : false;
};
